import { useCallback } from 'react';

import { useTelemetry } from '@order/Telemetry';

/**
 * Telemetry events for the group ordering host and invitee funnels.
 */
export const useGroupOrderTelemetry = () => {
  const { track } = useTelemetry();

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const trackCreateSuccess = useCallback(() => {
    track('group_ordering.create.success');
  }, [track]);

  const trackCreateFailure = useCallback(() => {
    track('group_ordering.create.failure');
  }, [track]);

  const trackJoinSuccess = useCallback(() => {
    track('group_ordering.join.success');
  }, [track]);

  const trackJoinFailure = useCallback(() => {
    track('group_ordering.join.failure');
  }, [track]);

  const trackCancelSuccess = useCallback(() => {
    track('group_ordering.cancel.success');
  }, [track]);

  const trackLeaveSuccess = useCallback(() => {
    track('group_ordering.leave.success');
  }, [track]);

  const trackItemActionFailure = useCallback(() => {
    track('group_ordering.item_action.failure');
  }, [track]);

  return {
    trackCreateSuccess,
    trackCreateFailure,
    trackJoinSuccess,
    trackJoinFailure,
    trackCancelSuccess,
    trackLeaveSuccess,
    trackItemActionFailure,
  };
};
